import { Route, Routes } from "react-router-dom";

import AccountManager from "components/AccountManager";
import Dashboard from "components/Dashboard";
import DocumentManager from "components/DocumentManager";
import ECRManager from "components/ECR";
import AnnouncementsManager from "components/NIAPAdmin/AnnouncementsManager";
import AtypicalFilesManager from "components/NIAPAdmin/AtypicalFilesManager/index.jsx";
import EventsManager from "components/NIAPAdmin/EventsManager";
import ExternalLinksManager from "components/NIAPAdmin/ExternalLinksManager";
import FAQManager from "components/NIAPAdmin/FAQs";
import GlossaryManager from "components/NIAPAdmin/GlossaryManager";
import LabgramsManager from "components/NIAPAdmin/LabgramsManager";
import PolicyLettersManager from "components/NIAPAdmin/PolicyLetters";
import SiteSettingsManager from "components/NIAPAdmin/SiteSettingsManager/SiteSettingsManager.screen";
import TechnicalCommunitiesManager from "components/NIAPAdmin/TechnicalCommunitiesManager/index.jsx";
import OrganizationManager from "components/OrganizationManager";
import FileTable from "components/ProjectFiles";
import PPManager from "components/ProtectionProfiles/PPManager";
import QA from "components/QA/index.jsx";
import TechDecisionManager from "components/TechnicalDecisions/Manager";
import TechnicalQueryManager from "components/TRRTS/TRRTSManager";
import VirtTeams from "components/VirtualTeams";

const LegacyRoutes = ({ selectedDashBoard }: { selectedDashBoard: string }) => {
  return (
    <Routes>
      {/* NOTE: I am leaving these routes here for now. They will need to be migrated to the new route files as we go */}
      {/* TODO: MIGRATE ALL THESE ROUTES TO THE ROUTE FILE */}

      {/* ======== ROUTES NEEDING MIGRATION ======= */}
      <Route path="accounts/*" element={<AccountManager />} />
      <Route path="organizations/*" element={<OrganizationManager />} />
      <Route path="protectionprofiles/*" element={<PPManager />} />
      <Route path="question-answer/*" element={<QA />} />
      <Route path="virtualteams/*" element={<VirtTeams />} />
      <Route path="technicalqueries/*" element={<TechnicalQueryManager />} />
      <Route path="technical-decisions/*" element={<TechDecisionManager />} />
      <Route path="ecr-comments/*" element={<ECRManager />} />
      <Route path="events-manager/*" element={<EventsManager />} />
      <Route
        path="announcements-manager/*"
        element={<AnnouncementsManager />}
      />
      <Route path="glossary-manager/*" element={<GlossaryManager />} />
      <Route path="documents/*" element={<DocumentManager />} />
      <Route path="faqs/*" element={<FAQManager />} />
      <Route path="external-links/*" element={<ExternalLinksManager />} />
      <Route
        path=":managerArea/details/:id2?/:subtype?/:id/:type/files"
        element={<FileTable />}
      />
      <Route path="labgrams-manager/*" element={<LabgramsManager />} />
      <Route path="policy-letters/*" element={<PolicyLettersManager />} />
      <Route
        path="technical-communities/*"
        element={<TechnicalCommunitiesManager />}
      />
      <Route path="upload-atypical" element={<AtypicalFilesManager />} />
      <Route path="site-settings" element={<SiteSettingsManager />} />
      <Route
        path=""
        element={<Dashboard selectedDashBoard={selectedDashBoard} />}
      />
    </Routes>
  );
};

export default LegacyRoutes;

/* ======== MIGRATED ROUTES ======= */
/* <Route path="document-serial-numbers/*" element={<DocSerialNumberManager />} /> - moved to routes file */
/* <Route path="ear-reviews/*" element={<EARManager />} /> - moved to routes file*/
/* <Route path="nist/*" element={<NISTManager />} /> - moved to routes file */
/* <Route path="pcm/*" element={<PCMManager />} /> - moved to routes file */
/* <Route path="products/*" element={<ProductManager />} /> - moved to routes file */
/* <Route path="reports/*" element={<ReportsCenter />} /> - moved to routes file */
/* <Route path="training-center/*" element={<TrainingCenter />} /> */
/* <Route path="mailing-lists/*" element={<MailingList />} /> */
